/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, BigNumberish } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { FloraArmy } from "../FloraArmy";

export class FloraArmy__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    ensRegistryAddr: string,
    initEnhancer: BigNumberish,
    baseURI: string,
    powerLevels: [
      BigNumberish,
      BigNumberish,
      BigNumberish,
      BigNumberish,
      BigNumberish
    ],
    metadataNames: [string, string, string, string, string],
    overrides?: Overrides
  ): Promise<FloraArmy> {
    return super.deploy(
      ensRegistryAddr,
      initEnhancer,
      baseURI,
      powerLevels,
      metadataNames,
      overrides || {}
    ) as Promise<FloraArmy>;
  }
  getDeployTransaction(
    ensRegistryAddr: string,
    initEnhancer: BigNumberish,
    baseURI: string,
    powerLevels: [
      BigNumberish,
      BigNumberish,
      BigNumberish,
      BigNumberish,
      BigNumberish
    ],
    metadataNames: [string, string, string, string, string],
    overrides?: Overrides
  ): TransactionRequest {
    return super.getDeployTransaction(
      ensRegistryAddr,
      initEnhancer,
      baseURI,
      powerLevels,
      metadataNames,
      overrides || {}
    );
  }
  attach(address: string): FloraArmy {
    return super.attach(address) as FloraArmy;
  }
  connect(signer: Signer): FloraArmy__factory {
    return super.connect(signer) as FloraArmy__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): FloraArmy {
    return new Contract(address, _abi, signerOrProvider) as FloraArmy;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "ensRegistryAddr",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "initEnhancer",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "baseURI",
        type: "string",
      },
      {
        internalType: "int256[5]",
        name: "powerLevels",
        type: "int256[5]",
      },
      {
        internalType: "string[5]",
        name: "metadataNames",
        type: "string[5]",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "minionID",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "branchAddress",
        type: "address",
      },
      {
        indexed: true,
        internalType: "bool",
        name: "armed",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "int256",
        name: "environmentFactor",
        type: "int256",
      },
      {
        indexed: false,
        internalType: "int256",
        name: "power",
        type: "int256",
      },
    ],
    name: "MinionState",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "minionID",
        type: "uint256",
      },
    ],
    name: "arm",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "baseURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "minionID",
        type: "uint256",
      },
    ],
    name: "boost",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string[5]",
        name: "metadataNames_",
        type: "string[5]",
      },
    ],
    name: "changeMetadataNames",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "int256[5]",
        name: "powerLevels_",
        type: "int256[5]",
      },
    ],
    name: "changePowerLevels",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "enhancerContract",
    outputs: [
      {
        internalType: "contract ENHR",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "ens",
    outputs: [
      {
        internalType: "contract ENS",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "commander",
        type: "address",
      },
    ],
    name: "getMinionIDs",
    outputs: [
      {
        internalType: "uint256[]",
        name: "minionIDs",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "minionID",
        type: "uint256",
      },
    ],
    name: "getMinionInfo",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
      {
        internalType: "int256",
        name: "",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "",
        type: "int256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "minionID",
        type: "uint256",
      },
    ],
    name: "getMinionProfile",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "branch",
            type: "address",
          },
          {
            internalType: "bool",
            name: "armed",
            type: "bool",
          },
          {
            internalType: "int256",
            name: "price",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "power",
            type: "int256",
          },
          {
            internalType: "string",
            name: "uri",
            type: "string",
          },
        ],
        internalType: "struct ArmyBase.MinionProfile",
        name: "profile",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "minionIDs",
        type: "uint256[]",
      },
    ],
    name: "getTeamProfile",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "branch",
            type: "address",
          },
          {
            internalType: "bool",
            name: "armed",
            type: "bool",
          },
          {
            internalType: "int256",
            name: "price",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "power",
            type: "int256",
          },
          {
            internalType: "string",
            name: "uri",
            type: "string",
          },
        ],
        internalType: "struct ArmyBase.MinionProfile[]",
        name: "teamProfile",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "minionID",
        type: "uint256",
      },
    ],
    name: "grant",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "minionID",
        type: "uint256",
      },
    ],
    name: "heal",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "initPower",
    outputs: [
      {
        internalType: "int256",
        name: "",
        type: "int256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "minionID",
        type: "uint256",
      },
    ],
    name: "liberate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "metadataNames",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "minionID",
        type: "uint256",
      },
    ],
    name: "minionExists",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "minions",
    outputs: [
      {
        internalType: "address",
        name: "branchAddr",
        type: "address",
      },
      {
        internalType: "bool",
        name: "armed",
        type: "bool",
      },
      {
        internalType: "int256",
        name: "envFactor",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "power",
        type: "int256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "powerLevels",
    outputs: [
      {
        internalType: "int256",
        name: "",
        type: "int256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "branchHash",
        type: "bytes32",
      },
    ],
    name: "recruit",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "serialNumber",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenOfOwnerByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "minionID",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "minionID",
        type: "uint256",
      },
    ],
    name: "train",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "baseURI_",
        type: "string",
      },
    ],
    name: "updateBaseURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";
